export default __webpack_public_path__ + "static/media/fully_reg_det_topology_reduced.b22b523e.png";